var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 15,
    fill: "none",
    viewBox: "0 0 30 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M22.496 15H7.503l-.003-.779c0-1.573.125-2.482 1.985-2.912 2.105-.486 4.18-.92 3.181-2.761C9.71 3.093 11.824 0 15 0c3.114 0 5.282 2.979 2.332 8.549-.968 1.83 1.033 2.265 3.181 2.761 1.863.43 1.987 1.34 1.987 2.916l-.003.774Zm6.014-2.768c-1.613-.372-3.113-.698-2.386-2.07 2.211-4.178.586-6.412-1.75-6.412-1.581 0-2.81 1.021-2.81 2.905 0 4.879 2.835 2.212 2.807 8.345h5.627l.002-.579c0-1.182-.093-1.866-1.49-2.188ZM.002 15H5.63c-.026-6.133 2.807-3.465 2.807-8.345 0-1.884-1.229-2.905-2.81-2.905-2.336 0-3.961 2.234-1.749 6.411.727 1.374-.773 1.699-2.386 2.072C.092 12.554 0 13.239 0 14.42l.003.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashClients);
export default __webpack_public_path__ + "static/media/dash_clients.9bd9c42d0f062fd956c0ecc2e11b97a6.svg";
export { ForwardRef as ReactComponent };